import { render, staticRenderFns } from "./AgendaVideoDialog.vue?vue&type=template&id=77cbeb66&scoped=true"
import script from "./AgendaVideoDialog.vue?vue&type=script&lang=js"
export * from "./AgendaVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./AgendaVideoDialog.vue?vue&type=style&index=0&id=77cbeb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cbeb66",
  null
  
)

export default component.exports